<div class="mat-app-background" style="height: 100%">
  @if (!(isLoadingIndicator$() | async)) {
    <mat-card appearance="raised">
      <mat-progress-bar class="progress-loader"
        [mode]="(isLoadingIndicator$() | async) ? 'indeterminate' : 'determinate'" value="0"
      color="primary"></mat-progress-bar>
      <mat-card-content class="header-card">
        <div class="control-panel-container">
          <div class="control-panel-header">
            <h1>Welcome to InvFlow!</h1>
          </div>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card appearance="raised" class="overview-panel">
      <mat-card-content>
        <h2>Version Update</h2>
        <p>InvFlow has been updated.</p>
        <p>If you encounter any errors please reach out, and the team will resolve your issues.</p>
        <br/>
        <h2>Updates:</h2>
        <ul>
          <li><b>Application Framework: </b> The underlying application framework has been upgraded, which includes performance updates, visual updates and security updates.</li>
        </ul>
      </mat-card-content>
    </mat-card>
  } @else {
    <div style="height: 100%; display: flex; justify-content: flex-start; align-items: center; flex-direction: column;">
      <ng-lottie [options]="options"></ng-lottie>
      <!--<h1 style="font-weight: bolder">We are currently working on it...</h1>-->
    </div>
  }
</div>

